/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Audio_Embed_Export_Source_Option_AdInputs */



/**
* | output |
* | --- |
* | "AD • {label}" |
*
* @param {Audio_Embed_Export_Source_Option_AdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_source_option_ad = /** @type {((inputs: Audio_Embed_Export_Source_Option_AdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Source_Option_AdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`PUBLICITÉ • ${i?.label}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`广告 • ${i?.label}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
	return /** @type {LocalizedString} */ (`AD • ${i?.label}`)
});